/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RapportHopeParameterDataDto } from './RapportHopeParameterDataDto';
import {
    RapportHopeParameterDataDtoFromJSON,
    RapportHopeParameterDataDtoFromJSONTyped,
    RapportHopeParameterDataDtoToJSON,
} from './RapportHopeParameterDataDto';

/**
 * 
 * @export
 * @interface GetRapportHopeForViewQuery
 */
export interface GetRapportHopeForViewQuery {
    /**
     * 
     * @type {number}
     * @memberof GetRapportHopeForViewQuery
     */
    idrapportHope?: number;
    /**
     * 
     * @type {Array<RapportHopeParameterDataDto>}
     * @memberof GetRapportHopeForViewQuery
     */
    currentParameterValues?: Array<RapportHopeParameterDataDto> | null;
}

/**
 * Check if a given object implements the GetRapportHopeForViewQuery interface.
 */
export function instanceOfGetRapportHopeForViewQuery(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetRapportHopeForViewQueryFromJSON(json: any): GetRapportHopeForViewQuery {
    return GetRapportHopeForViewQueryFromJSONTyped(json, false);
}

export function GetRapportHopeForViewQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRapportHopeForViewQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idrapportHope': !exists(json, 'idrapportHope') ? undefined : json['idrapportHope'],
        'currentParameterValues': !exists(json, 'currentParameterValues') ? undefined : (json['currentParameterValues'] === null ? null : (json['currentParameterValues'] as Array<any>).map(RapportHopeParameterDataDtoFromJSON)),
    };
}

export function GetRapportHopeForViewQueryToJSON(value?: GetRapportHopeForViewQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idrapportHope': value.idrapportHope,
        'currentParameterValues': value.currentParameterValues === undefined ? undefined : (value.currentParameterValues === null ? null : (value.currentParameterValues as Array<any>).map(RapportHopeParameterDataDtoToJSON)),
    };
}

